'use strict';

const processInclude = require('base/util');
$(document).ready(function () {
	processInclude(require('./product/detail'));
	processInclude(require('./components/productLoyaltyBeans'));
	processInclude(require('adyen/adyen/express/product/expressPayments'));
	processInclude(require('./product/bundleProducts'));
	processInclude(require('./components/pdpStickyBar'));
	processInclude(require('./components/productPackSelect'));
	processInclude(require('./components/buyOnlineModal'));
});
